import { useQueryClient } from '@tanstack/react-query'
import { useRealtime } from '@/lib/ws/useRealtime'

export function HrRealtime() {
  const qc = useQueryClient()
  useRealtime(
    (event) => event.includes('hr.') || event.startsWith('documents.'),
    () => {
      void qc.invalidateQueries({ queryKey: ['hr'] })
      void qc.invalidateQueries({ queryKey: ['documents'] })
    },
  )
  return null
}
